import { Dialog } from 'primereact/dialog';

const PropuestasDialog = ({ visible, onCancel, codigo }) => {
    return (
        <Dialog 
            header="Propuestas " 
            visible={visible} 
            className="p-fluid custom-dialog"
            onHide={onCancel}
        >
            <div className="grid">
            </div>
        </Dialog>
    );
};

export default PropuestasDialog;
